export default __webpack_public_path__ + "static/media/7th.034d6995.webp";